import { service } from '../api/axios';

export const startLesson = async (id: string) => {
  await service
    .post(`/progress/lesson/${id}/start`)
    .then((responseFromAPI) => responseFromAPI.data);
};

export const completeLesson = async (id: string) => {
  await service
    .post(`/progress/lesson/${id}/complete`)
    .then((responseFromAPI) => responseFromAPI.data);
};

export const sendFeedback = async (
  courseId: string,
  feedback: string,
  rating: Number
) => {
  await service
    .post(`/progress/course/${courseId}/feedback`, { feedback, rating })
    .then((responseFromAPI) => responseFromAPI.data);
};
